import dayjs from "dayjs";
import { TripCategory } from "@hopper-b2b/types";
import {
  getDepartureDate,
  getReturnDate,
  getTripCategory,
} from "@b2bportal/core-flights";
import { useSelector } from "react-redux";
import { DateTimeFormatStyle, useI18nContext } from "@hopper-b2b/i18n";

export const useFlightDatesString = (
  dateFormat = DateTimeFormatStyle.Custom({
    year: "numeric",
    month: "short",
    day: "2-digit",
  }),
  separator = " - "
): string => {
  const departureDate = useSelector(getDepartureDate);
  const returnDate = useSelector(getReturnDate);
  const tripCategory = useSelector(getTripCategory);
  const { formatDateTime } = useI18nContext();

  if (!departureDate) {
    return "";
  }

  const dates = [formatDateTime(dayjs(departureDate).toDate(), dateFormat)];
  if (tripCategory !== TripCategory.ONE_WAY) {
    dates.push(formatDateTime(dayjs(returnDate).toDate(), dateFormat));
  }

  return dates.join(separator);
};
